<script setup lang="ts">
import DesktopLocationsMenu from '@layout/nav-v2/desktop/components/menus/DesktopLocationsMenu.vue';
</script>

<template>
  <div
    :class="[
      'top-navbar-desktop-panel',
      'border-0 border-t border-solid border-gray rounded-b-lg',
      'w-full h-fit',
      'px-8 py-6',
      'flex justify-center',
      'bg-white'
    ]"
  >
    <DesktopLocationsMenu />
  </div>
</template>

<style scoped lang="scss">
@use '@styles/variables/colors' as *;

.top-navbar-desktop-panel {
  box-shadow: 0 -1px 0 0 $colorGray inset;
}
</style>
